export default {"src":"/_next/static/media/rewards-mask.97b33094.svg","height":902,"width":1014,"blurWidth":0,"blurHeight":0};